import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class WhereToWatchGuard  {
  
  constructor( private router: Router, private storageService: StorageService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateHelper();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateHelper();
  }

  canActivateHelper() {
    if(window.innerWidth <= 768 && Boolean(this.storageService.getLocalStore('u_id'))) {
      this.router.navigateByUrl('account/m/where-to-watch-mobile');
      return false
    }
    else if(window.innerWidth > 768 ) {
      return true;
      
    }
   
    return true;
  }
}
